module.exports = __webpack_public_path__ + "static/media/search-white.9cfd0be2.svg";